import React, { useState, useEffect } from "react";
import { Dropdown, DropdownItem } from "flowbite-react";
import { IoMdArrowDropright } from "react-icons/io";
import { TiArrowSortedDown } from "react-icons/ti";
import { FaXmark } from "react-icons/fa6";
import { useSelector, useDispatch } from "react-redux";
import {
  getL2SheetProperty,
  setCommonFilters,
  updateLevel2Properties,
} from "../../WorkbookSlice";
import { FaCheck } from "react-icons/fa";
import { handleFilterInDashboard } from "../../../smallFunction/SmallFunctions";

export default function FilterDropDown({
  columnName,
  filterComponentType,
  setFilterType,
  showApplyBtn,
  setShowApplyBtn,
  item,
  dashboardSheetID: dashIDs,
  isFilterVisibleInDashboard,
  item: data,
  Sheetid,
  index,
  commonFilters,
  currentSheetType,
  dashboardType,
  filterArray,
}) {
  const { visibleFilter, isCommonFilter, rename, dataType, format } = data;
  // console.log(data);
  // // console.log(isCommonFilter);
  const caption = () => {
    switch (format) {
      case "YYYY":
      case "FYyyyy-yy":
        return "Years";
      case "MMM-YY":
      case "MMMM":
        return "Months";
      case "Wx":
        return "Week";
      case "dddd":
        return "Weekday";
      case "dd-mm-yyyy":
      case "DD/MM/YYYY":
        return "Date";
      default:
        return null;
    }
  };
  const filterComponents = [
    { label: "Sindle Value List", value: "SingleValueList" },
    // { label: "Single Value Slider", value: "SingleValueSlider" },
    { label: "Multiple Value List", value: "MultiValueList" },
    { label: "Multi Value Dropdown", value: "MultiValueDropdown" },
    { label: "Multi Value Custom List", value: "MultiValueCustomList" },
    // { label: "Single Value Range", value: "SingleValueRange" },
  ];
  const dispatch = useDispatch();
  const [selectedFilterComp, setSelectedFilterComp] =
    useState(filterComponentType);
  // // console.log(selectedFilterComp);

  const [commonFilterBoolean, setCommonFilterBoolean] =
    useState(isCommonFilter);

  // Initialize the Show Apply Button state from localStorage or Redux
  useEffect(() => {
    const applyBtnState = localStorage.getItem(`applyBtnState_${Sheetid}`);
    if (applyBtnState !== null) {
      setShowApplyBtn(JSON.parse(applyBtnState));
    }
  }, [Sheetid]);

  const toggleCommonFilter = () => {
    const newCommonFilterStatus = !commonFilterBoolean;
    // console.log(newCommonFilterStatus);
    setCommonFilterBoolean(newCommonFilterStatus);
    const updatedObject = {
      ...data,
      isCommonFilter: newCommonFilterStatus,
      isRelevant: data.isRelevant,
    };
    // console.log(updatedObject);
    dispatch(
      setCommonFilters({
        operation: "UPDATE",
        value: updatedObject,
        Sheetid,
      })
    );
  };

  // console.log(filterArray);

  const handleUpdateFilter = (
    filterComponentType,
    isFilterVisible,
    isRelevant,
    isApplyVisible
  ) => {
    // console.log(isApplyVisible);
    let sheetFilterArray, commonFilterArray;
    const itemFoundInQueryFilters = filterArray[index];
    // console.log(itemFoundInQueryFilters);
    const itemFoundInCommonFilters = commonFilters[index];
    // console.log(itemFoundInCommonFilters);

    if (itemFoundInQueryFilters) {
      // console.log(itemFoundInQueryFilters);

      // Update the specific item in the filterArray
      const updatedFilterArray = [...filterArray]; // Clone the array
      updatedFilterArray[index] = { ...item, filterComponentType }; // Update the item at the index

      sheetFilterArray = updatedFilterArray;
      // console.log(sheetFilterArray);
      dispatch(
        updateLevel2Properties({
          reduxKey: "filters",
          Sheetid,
          parentKey: "query",
          value: {
            ...item,
            filterComponentType,
            isRelevant,
            visibleFilter: isFilterVisible,
            isApplyVisible,
          },
          itemInArray: true,
          index: index,
        })
      );
    }

    if (itemFoundInCommonFilters) {
      // console.log(itemFoundInCommonFilters);

      // If needed, handle updates for commonFilters similarly
      const updatedCommonFilters = [...commonFilters];
      updatedCommonFilters[index] = {
        ...item,
        filterComponentType,
        isRelevant,
        visibleFilter: isFilterVisible,
      };

      commonFilterArray = updatedCommonFilters;
      // console.log(commonFilterArray);
      dispatch(
        setCommonFilters({
          Sheetid,
          operation: "UPDATE",
          value: {
            ...item,
            filterComponentType,
            isRelevant,
            visibleFilter: isFilterVisible,
          },
        })
      );
    }
  };

  const handleShowApplyBtnToggle = () => {
    const newShowApplyBtn = !showApplyBtn;
    setShowApplyBtn(newShowApplyBtn);
    localStorage.setItem(
      `applyBtnState_${Sheetid}`,
      JSON.stringify(newShowApplyBtn)
    );
    handleUpdateFilter(
      data.filterComponentType,
      data.visibleFilter,
      data.isRelevant,
      newShowApplyBtn
    );
  };
  const handleRemoveItem = (item) => {
    // console.log(item.rename);
    dispatch(
      setCommonFilters({
        operation: "REMOVE",
        value: item,
        Sheetid,
      })
    );
  };
  // console.log(rename);
  // console.log(caption());

  return (
    <main className="w-full flex items-center justify-between px-1">
      <button
        className={`truncate w-[80%] text-left overflow-hidden font-light ${
          isFilterVisibleInDashboard
            ? "items-center justify-between flex w-full"
            : " "
        }`}
      >
        {dataType === "Date"
          ? caption() && `${caption()}(${rename})`
            ? `${caption()}(${rename})`
            : rename
          : rename}
        {dashboardType === "makeDashboard" && isFilterVisibleInDashboard ? (
          <FaXmark
            className="font-light cursor-pointer text-transparent hover:text-gray-600"
            onClick={() =>
              handleFilterInDashboard({
                item,
                dashIDs,
                dispatch,
                setCommonFilters,
              })
            }
          />
        ) : null}
      </button>
      {dashboardType === "makeDashboard" && !isFilterVisibleInDashboard ? (
        <Dropdown
          label={
            <TiArrowSortedDown className="text-xl text-white relative left-[75%] hover:text-black cursor-pointer" />
          }
          placement="left-start"
          dismissOnClick={true}
          style={{ position: "relative", right: "10px" }}
          className="w-60 mr-10 mt-3"
        >
          {/* <Dropdown.Item>Edit Filter</Dropdown.Item> */}
          {/* <Dropdown
            label={
              <Dropdown.Item className="w-60 py-1 relative top-1 text-sm font-normal flex items-center justify-between">
                Edit Filter Type{" "}
                <IoMdArrowDropright className="text-xl text-black" />
              </Dropdown.Item>
            }
            placement="left-start"
            arrowIcon={false}
            className="text-black flex items-center justify-left gap-2 text-base font-UberMoveTextRegular p-0 ml-4 shadow-xl w-full"
            style={{
              color: "black",
              marginTop: "-10px",
              marginLeft: "0px",
              paddingTop: "0px",
              paddingBottom: "0px",
            }}
          >
            {filterComponents
              .filter(
                (comp) =>
                  !(
                    data.dataType === "String" &&
                    comp.value === "SingleValueRange"
                  )
              )
              .map((comp, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={() => {
                    setFilterType(comp.value);
                    handleUpdateFilter(
                      comp.value,
                      data.visibleFilter,
                      data.isRelevant
                    );
                  }}
                  className="flex items-center justify-between w-[239px]"
                >
                  {comp.label}
                  {data.filterComponentType === comp.value ? (
                    <FaCheck className="text-lg" />
                  ) : null}
                </Dropdown.Item>
              ))}
          </Dropdown> */}
          <DropdownItem
            className="w-full flex items-center justify-start gap-2 pr-0"
            onClick={() => {
              toggleCommonFilter();
            }}
          >
            Apply On WorkSheets{" "}
            {commonFilterBoolean ? <FaCheck className="text-lg" /> : null}
          </DropdownItem>
          <Dropdown.Item
            onClick={handleShowApplyBtnToggle}
            className="w-full flex items-center justify-start gap-2 pr-0"
          >
            Show Apply Button
            {showApplyBtn ? <FaCheck className="text-lg" /> : null}
          </Dropdown.Item>
          {/* <Dropdown.Item
            onClick={() =>
              handleUpdateFilter(
                data.filterComponentType,
                data.visibleFilter,
                !data.isRelevant
              )
            }
            className="w-full flex items-center justify-start gap-2 pr-0"
          >
            Only Relevant Values{" "}
            {data.isRelevant ? <FaCheck className="text-lg" /> : null}
          </Dropdown.Item> */}
          <Dropdown.Item
            onClick={() =>
              handleUpdateFilter(
                data.filterComponentType,
                !data.visibleFilter,
                data.isRelevant
              )
            }
            className="w-full flex items-center justify-start gap-2 pr-0"
          >
            Show Filter{" "}
            {data.visibleFilter ? <FaCheck className="text-lg" /> : null}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleRemoveItem(item)}
            className="w-full flex items-center justify-start gap-2 pr-0"
          >
            Remove
          </Dropdown.Item>
        </Dropdown>
      ) : null}
    </main>
  );
}
